import React from 'react';

const labelStyle = {
  position: 'absolute',
  top: -9,
  left: 10,
  fontSize: 11,
  fontWeight: 500,
  color: '#757575',
  background: '#fff',
  padding: '0 4px',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 'calc(100% - 16px)',
  letterSpacing: '.2px',
};

const wrapStyle = {
  position: 'relative',
};

export function FloatInput({ label, required, id, style = {}, ...props }) {
  return (
    <div style={{...wrapStyle, ...style}}>
      <input
        id={id}
        className="fd-input"
        style={{height:40, padding:'0 12px'}}
        {...props}
      />
      <label style={labelStyle} htmlFor={id}>
        {label}{required && <span style={{color:'#B91C1C',marginLeft:2}}>*</span>}
      </label>
    </div>
  );
}

export function FloatSelect({ label, required, id, children, style = {}, ...props }) {
  return (
    <div style={{...wrapStyle, ...style}}>
      <select
        id={id}
        className="fd-input"
        style={{height:40, padding:'0 28px 0 12px', cursor:'pointer', appearance:'none', WebkitAppearance:'none', width:'100%'}}
        {...props}
      >
        {children}
      </select>
      <label style={labelStyle} htmlFor={id}>
        {label}{required && <span style={{color:'#B91C1C',marginLeft:2}}>*</span>}
      </label>
      <span style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',pointerEvents:'none',color:'#9E9E9E',fontSize:12}}>▾</span>
    </div>
  );
}

export function FloatTextarea({ label, required, id, style = {}, className = '', ...props }) {
  return (
    <div style={{...wrapStyle, ...style}}>
      <textarea
        id={id}
        className={'fd-textarea ' + className}
        style={{paddingTop:12}}
        {...props}
      />
      <label style={labelStyle} htmlFor={id}>
        {label}{required && <span style={{color:'#B91C1C',marginLeft:2}}>*</span>}
      </label>
    </div>
  );
}
